<script>

    import { toast } from 'bulma-toast'
    import { tracingsStore, shipmentStore } from '../stores'

    import TracingsService from '../$services/tracings.service'
    import DateMethod from '../$methods/date.method'

    import Table from '../$components/table.svelte'
    import Delete from '../$components/button.delete.svelte'

    let loading = false

    getTracings()

    async function getTracings() {
    
        loading = true
        const resp = await TracingsService.getTracings($shipmentStore._id)
        loading = false
    
        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})
    
        tracingsStore.set(resp.data)
    }

    async function deleteTracing(tracingId) {
    
        loading = true
        const resp = await TracingsService.deleteTracing(tracingId)
        loading = false
    
        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})
    
        tracingsStore.remove(tracingId)
    }

</script>

<Table items={ $tracingsStore.length } { loading }>
    <thead>
        <tr>
            <th>Historial</th>
        </tr>
    </thead>
    <tbody>
        {#each $tracingsStore as tracing}
            <tr>
                <td>
                    <div>
                        <span class="is-size-7 has-text-grey">{ DateMethod.dateTimeLarge(tracing.created) }</span>
                        <span class="is-flex is-justify-content-space-between is-align-items-center">
                            <span>{ tracing.admin.email }</span>
                            <Delete on:confirm={() => deleteTracing(tracing._id)} size="small" />
                        </span>
                        <span>{ tracing.comment }</span>
                    </div>
                </td>
            </tr>
        {/each}
    </tbody>
</Table>